import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Paper, Typography } from '@mui/material';
import { LoginTemplate } from '../../Components/Templates/LoginTemplate';
import PrimaryButton from '../../Components/Button/PrimaryButton';

const EmailConfirmation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <LoginTemplate
      title={
        <Typography
          sx={{
            py: 2,
            textAlign: "center",
            color: { xs: "common.white", sm: "primary.main" },
            fontWeight: 700,
            fontSize: "1.5em" 
          }}
        >
          {t('email_patvirtinimas') || 'El. pašto patvirtinimas'}
        </Typography>
      }
    >
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 2, 
          width: '100%', 
          maxWidth: 480,
          mx: 'auto' 
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Alert severity="success" sx={{ mb: 3 }}>
            El. paštas patvirtintas
          </Alert>
          <Typography sx={{ mb: 3, fontSize: '16px', color: '#666' }}>
            Jūsų profilį aktyvuosime arba su
   Jumis susisieksime per 3 darbo dienas. Kilus klausimams kviečiame mums
   parašyti el. paštu diversity@diversity.lt
          </Typography>
          <PrimaryButton
            onClick={() => navigate('/login')}
            text={t('grizti_i_prisijungima') || 'Grįžti į prisijungimą'}
          />
        </Box>
      </Paper>
    </LoginTemplate>
  );
};

export default EmailConfirmation;
